<template>
  <li class="dropdown_menu" :class="bookManagementListCssObj">
    <a v-b-toggle.booksCollapse>
      <b-icon-book />
      <span class="link-title menu_hide ml-1">หนังสือ</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="booksCollapse" :visible="false" accordion="accordion">
      <main-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import AuthMixin from "@/mixins/auth-mixin.js";
import CustomUserPermissionMixin from "@/mixins/custom-user-permission-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainCollapseMenu,
  },
  mixins: [AuthMixin, CustomUserPermissionMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
      comId: this.$store.state.Company.companyInfo.id,
    };
  },
  computed: {
    bookManagementListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  mounted() {
    if (checkSubMenuAccess({ menu: "book-management" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการหนังสือ",
        to: {
          name: "book.management.index",
        },
      });
    }
    if (checkSubMenuAccess({ menu: "book-delivery" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "การจัดส่งหนังสือ",
        to: {
          name: "book.delivery",
        },
      });
    }
    if (checkSubMenuAccess({ menu: "book-pickup" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "การรับหนังสือที่สถาบัน",
        to: {
          name: "book.pickup",
        },
      });
    }
    if (checkSubMenuAccess({ menu: "book-delivery-purchase-report" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "รายงานการซื้อที่ต้องรับ/ส่งหนังสือ",
        to: {
          name: "book.book-delivery-purchase-report",
        },
      });
    }
  },
  watch: {
    $route: {
      handler: "checkActiveRoute",
      immediate: true,
    },
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
